import * as Types from '../generated/graphql';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type UpdateMentorshipProgramByIdMutationVariables = Types.Exact<{
  programId: Types.Scalars['Int']['input'];
  objects?: Types.InputMaybe<Types.MentorshipProgram_Set_Input>;
}>;


export type UpdateMentorshipProgramByIdMutation = { __typename?: 'mutation_root', update_mentorshipProgram_by_pk?: { __typename?: 'mentorshipProgram', id: number, name: string, createdAt?: any | null, createdByUserId?: string | null, workspaceLocationId?: number | null, workspaceId: number, workspaceLocation?: { __typename?: 'workspaceLocations', id: number, name: string, abbreviation?: string | null, city?: string | null, state?: string | null } | null, workspace?: { __typename?: 'workspaces', id: number, name: string } | null, mentorshipProgramModules: Array<{ __typename?: 'mentorshipProgramModule', id: number, name: string, order: number, content: string, duration?: number | null, createdAt: any }>, mentorshipSurveys: Array<{ __typename?: 'mentorshipSurvey', id: number, preSurveyEnabled: boolean, preSurveyLink?: string | null, preSurveyMentorRequired?: boolean | null, preSurveyMenteeRequired?: boolean | null, midSurveyEnabled: boolean, midSurveyLink?: string | null, midSurveyMentorRequired?: boolean | null, midSurveyMenteeRequired?: boolean | null, postSurveyEnabled: boolean, postSurveyLink?: string | null, postSurveyMentorRequired?: boolean | null, postSurveyMenteeRequired?: boolean | null }> } | null };


export const UpdateMentorshipProgramByIdDocument = gql`
    mutation updateMentorshipProgramById($programId: Int!, $objects: mentorshipProgram_set_input) {
  update_mentorshipProgram_by_pk(pk_columns: {id: $programId}, _set: $objects) {
    id
    name
    createdAt
    createdByUserId
    workspaceLocationId
    workspaceLocation {
      id
      name
      abbreviation
      city
      state
    }
    workspaceId
    workspace {
      id
      name
    }
    mentorshipProgramModules {
      id
      name
      order
      content
      duration
      createdAt
    }
    mentorshipSurveys {
      id
      preSurveyEnabled
      preSurveyLink
      preSurveyMentorRequired
      preSurveyMenteeRequired
      midSurveyEnabled
      midSurveyLink
      midSurveyMentorRequired
      midSurveyMenteeRequired
      postSurveyEnabled
      postSurveyLink
      postSurveyMentorRequired
      postSurveyMenteeRequired
    }
  }
}
    `;
export type UpdateMentorshipProgramByIdMutationFn = Apollo.MutationFunction<UpdateMentorshipProgramByIdMutation, UpdateMentorshipProgramByIdMutationVariables>;

/**
 * __useUpdateMentorshipProgramByIdMutation__
 *
 * To run a mutation, you first call `useUpdateMentorshipProgramByIdMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateMentorshipProgramByIdMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateMentorshipProgramByIdMutation, { data, loading, error }] = useUpdateMentorshipProgramByIdMutation({
 *   variables: {
 *      programId: // value for 'programId'
 *      objects: // value for 'objects'
 *   },
 * });
 */
export function useUpdateMentorshipProgramByIdMutation(baseOptions?: Apollo.MutationHookOptions<UpdateMentorshipProgramByIdMutation, UpdateMentorshipProgramByIdMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateMentorshipProgramByIdMutation, UpdateMentorshipProgramByIdMutationVariables>(UpdateMentorshipProgramByIdDocument, options);
      }
export type UpdateMentorshipProgramByIdMutationHookResult = ReturnType<typeof useUpdateMentorshipProgramByIdMutation>;
export type UpdateMentorshipProgramByIdMutationResult = Apollo.MutationResult<UpdateMentorshipProgramByIdMutation>;
export type UpdateMentorshipProgramByIdMutationOptions = Apollo.BaseMutationOptions<UpdateMentorshipProgramByIdMutation, UpdateMentorshipProgramByIdMutationVariables>;